import { render, staticRenderFns } from "./ModalViwCoordinador.vue?vue&type=template&id=f23f7f12&scoped=true&"
import script from "./ModalViwCoordinador.vue?vue&type=script&lang=ts&"
export * from "./ModalViwCoordinador.vue?vue&type=script&lang=ts&"
import style0 from "./ModalViwCoordinador.vue?vue&type=style&index=0&id=f23f7f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23f7f12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f23f7f12', component.options)
    } else {
      api.reload('f23f7f12', component.options)
    }
    module.hot.accept("./ModalViwCoordinador.vue?vue&type=template&id=f23f7f12&scoped=true&", function () {
      api.rerender('f23f7f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorCoordinador/ModalViwCoordinador.vue"
export default component.exports